import { FC } from 'react'
import { Box } from '@maas-components/core'
import { WidgetsOutlined } from '@maas-components/icons'
import { Sidebar } from '@shell-components/core'
import { ERoutes } from 'common/entities/routes'
import pkg from '../../../package.json'

type TAppSidebarProps = {
  paddingTop?: number
}

const AppSidebar: FC<TAppSidebarProps> = ({ children, paddingTop }) => {
  const menu = {
    title: {
      icon: <WidgetsOutlined />,
      name: 'Hotsite',
    },
    links: [{ name: 'Início', url: ERoutes.HOME }],
  }

  return (
    <Sidebar
      {...(typeof paddingTop === 'number' && { paddingTop })}
      menu={menu}
      version={pkg.version}
    >
      <Box mt={3}>{children}</Box>
    </Sidebar>
  )
}

export default AppSidebar
